/* tslint:disable:object-literal-shorthand */
import {Injectable} from '@angular/core';
import OLCesium from 'ol-cesium/src/olcs/OLCesium';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import Map from 'ol/Map';
import * as olProj from 'ol/proj';
import TileJSON from 'ol/source/TileJSON';
import VectorSource from 'ol/source/Vector';
import {Style} from 'ol/style';
import View from 'ol/View';
import {NinjaData} from '../../../models/ninja-data.model';
import GeoJSON from 'ol/format/GeoJSON';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import {DataService} from '../../../core/data.service';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {MapCountryDialogComponent} from '../../dialogs/map-mat-dialog/map-country-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class OlMapService {

  map;
  stations = [];
  country: NinjaData;
  private ol3d;


  constructor(private dataService: DataService,
              public dialog: MatDialog) {
  }

  initializingMap(): unknown {
    // This is the text that will show the country data, below the map, on click and on hover
    const status = document.getElementById('status');
    // Initializing the selected country variable
    let selected = null;

    // Setting a vector layer that loads the geojson
    const vector = new VectorLayer({
      source: new VectorSource({
        url: '../assets/custom.geo.json',
        format: new GeoJSON(),
      }),
      opacity: 0.6
    });

    const rasterLayer = new TileLayer({
      source: new TileJSON({
        url: 'https://a.tiles.mapbox.com/v3/aj.1x1-degrees.json?secure=1',
        crossOrigin: '',
      }),
    });


    // Setting the country's border highlight on click and on hover
    const highlightStyle = new Style({
      fill: new Fill({
        color: 'rgba(214,25,25,0.7)',
      }),
      stroke: new Stroke({
        color: '#030303',
        width: 1,
      }),
    });

    this.map = new Map({
      target: 'map',
      layers: [rasterLayer, vector],
      view: new View({
        center: olProj.fromLonLat([2.2, 46.2276]),
        zoom: 3.6
      })
    });

    this.map.on('click', (evt) => {

      if (selected !== null) {
        selected.setStyle(undefined);
        selected = null;
      }

      this.map.forEachFeatureAtPixel(evt.pixel, (f) => {
        selected = f;
        f.setStyle(highlightStyle);
        return true;
      });

      if (selected) {
        const c = selected.get('name');
        this.dataService.getCountryDetails(c).subscribe((country: NinjaData) => {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = false;
          dialogConfig.autoFocus = true;
          // dialogConfig.width = '300px';

          dialogConfig.data = {
            countryData: country
          };
          this.dialog.open(MapCountryDialogComponent, dialogConfig);
        });
      } else {
        status.innerHTML = '&nbsp;';
      }
    });

    this.map.on('pointermove', (e) => {
      if (selected !== null) {
        selected.setStyle(undefined);
        selected = null;
      }

      const countryHit = this.map.forEachFeatureAtPixel(e.pixel, (f) => {
        selected = f;
        f.setStyle(highlightStyle);
        return true;
      });

      this.map.getTargetElement().style.cursor = countryHit ? 'pointer' : '';
    });

    return this.map;
  }

  toggle3D(enabled: boolean): void {
    if (!this.ol3d) {
      this.ol3d = new OLCesium({map: this.map});
    }
    this.ol3d.setEnabled(enabled);
  }

}

